import App from './page'
import Vue from 'vue'
import TEXT from ':/PA/json/TEXT.json'
import CONFIG from ':/PA/json/CONFIG.json'

import '@/helpers/screen'

Vue.prototype.TEXT = TEXT
Vue.prototype.CONFIG = CONFIG

Vue.config.productionTip = false

new Vue({ render: h => h(App), abstract: true, el: App.el || '#app' }) //  allow App to use a different [el] target if defined
